"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _cookieHelper = require("./cookieHelper");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ActionBarItem = _interopRequireDefault(require("@rio-cloud/rio-uikit/lib/es/ActionBarItem"));
var _CookieDisclaimer = require("./CookieDisclaimer");
var _IFrameDialog = require("./IFrameDialog");
var _closeMenuOnEscapeHook = require("./closeMenuOnEscapeHook");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var USER_MENU_URL = 'https://user-menu.iam.rio.cloud';
var USER_MENU_LOCAL = 'http://localhost:3009';
var DefaultUserMenu = function DefaultUserMenu(_ref) {
  var _ref$disableCookieMod = _ref.disableCookieModal,
    disableCookieModal = _ref$disableCookieMod === void 0 ? false : _ref$disableCookieMod,
    _ref$environment = _ref.environment,
    environment = _ref$environment === void 0 ? 'production' : _ref$environment,
    _ref$localUserMenu = _ref.localUserMenu,
    localUserMenu = _ref$localUserMenu === void 0 ? false : _ref$localUserMenu,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
    logoutRedirectUri = _ref.logoutRedirectUri,
    preventLogoutRedirect = _ref.preventLogoutRedirect;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showDialog = _useState2[0],
    setShowDialog = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    hidePopover = _useState4[0],
    setHidePopover = _useState4[1];
  // the following variable is true when the consent cookies are not set
  // and false if they are set
  var _useState5 = (0, _react.useState)((0, _cookieHelper.getCookie)(_CookieDisclaimer.GA_CONSENT_COOKIE) === null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    enableCookieDisclaimer = _useState6[0],
    setEnableCookieDisclaimer = _useState6[1];
  (0, _closeMenuOnEscapeHook.useCloseMenuOnEscape)({
    isDialogOpen: showDialog,
    closeDialog: function closeDialog() {
      return setShowDialog(false);
    }
  });
  var iFrameUrl = environment === 'production' ? USER_MENU_URL : localUserMenu ? USER_MENU_LOCAL : undefined;
  var popOver = /*#__PURE__*/_react.default.createRef();
  (0, _react.useEffect)(function () {
    if (hidePopover && popOver.current) {
      popOver.current.hide();
    }
  });
  var hideDialog = function hideDialog() {
    setShowDialog(false);
  };
  return /*#__PURE__*/_react.default.createElement(_ActionBarItem.default, {
    id: 'userMenu'
  }, /*#__PURE__*/_react.default.createElement(_ActionBarItem.default.Icon, {
    onClick: function onClick() {
      setHidePopover(true);
      setShowDialog(true);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'icon rioglyph rioglyph-user',
    "data-cy": 'userMenu-icon'
  })), disableCookieModal !== true && enableCookieDisclaimer && /*#__PURE__*/_react.default.createElement(_CookieDisclaimer.CookieDisclaimer, {
    environment: environment,
    locale: locale,
    setEnableCookieDisclaimer: setEnableCookieDisclaimer
  }), showDialog && /*#__PURE__*/_react.default.createElement(_IFrameDialog.IFrameDialog, {
    show: showDialog,
    onClose: hideDialog,
    contentUrl: iFrameUrl,
    preventLogoutRedirect: preventLogoutRedirect,
    logoutRedirectUri: logoutRedirectUri
  }));
};
var _default = exports.default = DefaultUserMenu; // These will be silently ignored in React >= 19
// It's recommended to migrate to TS (that also removes the need to maintain a
// .d.ts file manually)
DefaultUserMenu.propTypes = {
  disableCookieModal: _propTypes.default.bool,
  environment: _propTypes.default.string.isRequired,
  localUserMenu: _propTypes.default.bool,
  locale: _propTypes.default.string,
  logoutRedirectUri: _propTypes.default.string,
  preventLogoutRedirect: _propTypes.default.bool
};